/* =========================================================
   BZ · Réplica Senzio — scripts da página de produto
   (carrossel de avaliações + barra fixa). Carrega só em produto.
   ========================================================= */
/* ===== reviews ===== */

(function () {
 "use strict";
 /* BZ: carrossel de avaliações (mesma lógica da Senzio; os cards vêm dos blocos da seção) */
 function initBzReviews() {
 document.querySelectorAll("[data-ser-reviews]:not([data-ser-ready])").forEach(function (section) {
 section.setAttribute("data-ser-ready", "true");
 var track = section.querySelector("[data-ser-track]");
 var prev = section.querySelector("[data-ser-previous]");
 var next = section.querySelector("[data-ser-next]");
 var pagination = section.querySelector("[data-ser-pagination]");
 if (!track || !prev || !next || !pagination) return;
 var cards = Array.prototype.slice.call(track.querySelectorAll(".ser-card"));
 var visibleDotCount = 7, updateTimer = null, resizeTimer = null, autoplayTimer = null, autoplayDelay = 5000, isHovered = false, isInteracting = false;
 var label = section.getAttribute("data-dot-label") || "Show review group";
 function reduced() { return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
 function gap() { var s = getComputedStyle(track); return parseFloat(s.columnGap) || parseFloat(s.gap) || 0; }
 function step() { return cards.length ? cards[0].getBoundingClientRect().width + gap() : (track.clientWidth || 1); }
 function visibleCount() { var st = step(); return st ? Math.max(1, Math.floor(track.clientWidth / st)) : 1; }
 function maxIndex() { return Math.max(0, cards.length - visibleCount()); }
 function current() { var st = step(); if (!st) return 0; return Math.max(0, Math.min(maxIndex(), Math.round(track.scrollLeft / st))); }
 function go(i, behavior) { var m = maxIndex(); var s = Math.max(0, Math.min(m, i)); track.scrollTo({ left: s * step(), behavior: behavior || (reduced() ? "auto" : "smooth") }); }
 function moveNext() { var c = current(); if (c >= maxIndex()) { go(0); return; } go(c + 1); }
 function movePrev() { var c = current(); if (c <= 0) { go(maxIndex()); return; } go(c - 1); }
 function renderDots(c) {
 pagination.innerHTML = "";
 var total = maxIndex() + 1, half = Math.floor(visibleDotCount / 2);
 var start = Math.max(0, c - half), end = Math.min(total, start + visibleDotCount);
 if (end - start < visibleDotCount) start = Math.max(0, end - visibleDotCount);
 for (var i = start; i < end; i++) {
 (function (idx) {
 var d = document.createElement("button");
 d.type = "button"; d.className = "ser-dot"; d.setAttribute("aria-label", label + " " + (idx + 1));
 if (idx === c) { d.classList.add("is-active"); d.setAttribute("aria-current", "true"); }
 d.addEventListener("click", function () { go(idx); restart(); });
 pagination.appendChild(d);
 })(i);
 }
 }
 function update() { var c = current(); renderDots(c); prev.style.opacity = c <= 0 ? "0.6" : "1"; next.style.opacity = c >= maxIndex() ? "0.6" : "1"; }
 function stop() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
 function start() { if (reduced() || isHovered || isInteracting || cards.length <= 1) return; stop(); autoplayTimer = setInterval(function () { if (document.hidden || isHovered || isInteracting) return; moveNext(); }, autoplayDelay); }
 function restart() { stop(); start(); }
 prev.addEventListener("click", function () { movePrev(); restart(); });
 next.addEventListener("click", function () { moveNext(); restart(); });
 track.addEventListener("scroll", function () { clearTimeout(updateTimer); updateTimer = setTimeout(update, 70); }, { passive: true });
 section.addEventListener("mouseenter", function () { isHovered = true; stop(); });
 section.addEventListener("mouseleave", function () { isHovered = false; start(); });
 track.addEventListener("pointerdown", function () { isInteracting = true; stop(); }, { passive: true });
 window.addEventListener("pointerup", function () { if (!isInteracting) return; isInteracting = false; setTimeout(function () { update(); start(); }, 180); }, { passive: true });
 track.addEventListener("touchstart", function () { isInteracting = true; stop(); }, { passive: true });
 track.addEventListener("touchend", function () { isInteracting = false; setTimeout(function () { update(); start(); }, 180); }, { passive: true });
 track.addEventListener("keydown", function (e) { if (e.key === "ArrowLeft") { e.preventDefault(); movePrev(); restart(); } if (e.key === "ArrowRight") { e.preventDefault(); moveNext(); restart(); } });
 window.addEventListener("resize", function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { go(current(), "auto"); update(); restart(); }, 130); });
 document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else start(); });
 update(); start(); setTimeout(update, 350); setTimeout(update, 900);
 });
 }
 if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initBzReviews); else initBzReviews();
 window.addEventListener("load", initBzReviews);
 document.addEventListener("shopify:section:load", initBzReviews);
})();

/* ===== barra fixa "セットを選ぶ" ===== */
(function () {
 "use strict";
 /* BZ: aparece só DEPOIS que o botão de compra sai da tela por cima; some quando ele volta.
    Usa IntersectionObserver (não roda nada a cada rolagem = mais leve). */
 function initBzSticky() {
  document.querySelectorAll("[data-bz-sticky]:not([data-bz-ready])").forEach(function (bar) {
   bar.setAttribute("data-bz-ready", "true");
   var sel = bar.getAttribute("data-target") || ".product__block--buy_buttons";
   var target = document.querySelector(sel) || document.querySelector("product-form, form[action*='/cart/add']");
   var btn = bar.querySelector("[data-bz-sticky-btn]");
   if (btn) btn.addEventListener("click", function (e) {
    e.preventDefault();
    var t = document.querySelector(sel) || target;
    if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
   });
   function set(on) {
    bar.classList.toggle("is-visible", on);
    document.documentElement.classList.toggle("bz-sticky-on", on);
   }
   if (!target) { set(false); return; }
   if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
     var e = entries[0];
     set(!e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
   } else {
    window.addEventListener("scroll", function () { set(target.getBoundingClientRect().bottom < 0); }, { passive: true });
   }
  });
 }
 if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initBzSticky); else initBzSticky();
 document.addEventListener("shopify:section:load", initBzSticky);
})();
